import { instance } from "@/lib/hooks";
import { createAxiosQuery, createAxiosMutation } from "@/hooks/react-query";

interface OnboardingEntityProgress {
  total: number;
  created_count: number;
  updated_count: number;
  failed_count: number;
}

export interface OnboardingProgress {
  status: "pending" | "error" | "complete";
  overall_progress: number;
  entities: Record<string, OnboardingEntityProgress>;
}

export type SmrtCoreSetupStatus = OnboardingProgress["status"];

export type SmrtCoreSetupResponse = OnboardingProgress;

export const useSmrtCoreSetupQuery = createAxiosQuery<
  { organizationId: string | number },
  SmrtCoreSetupResponse
>("smrt-core-setup", async (filters) =>
  instance.get<SmrtCoreSetupResponse>(
    `/smrt-core-setup/${filters!.organizationId}`
  )
);

export const useSmrtCoreSetupMutation = createAxiosMutation<
  void,
  unknown,
  { organizationId: string | number }
>(
  async ({ organizationId }) =>
    instance.post<void>(`/smrt-core-setup/${organizationId}`),
  {
    onSuccess: (queryClient) => {
      queryClient.invalidateQueries({ queryKey: ["smrt-core-setup"] });
    },
    successToast: () => ({
      message:
        "Smrt-Core onboarding has been initiated. This may take several minutes to complete.",
    }),
    errorToast: () => ({
      message: "Failed to initiate Smrt-Core onboarding. Please try again.",
    }),
  }
);

export const useSmrtCoreStopMutation = createAxiosMutation<
  void,
  unknown,
  { organizationId: string | number }
>(
  async ({ organizationId }) =>
    instance.delete<void>(`/smrt-core-setup/${organizationId}`),
  {
    onSuccess: (queryClient) => {
      queryClient.invalidateQueries({ queryKey: ["smrt-core-setup"] });
    },
    successToast: () => ({
      message: "Smrt-Core onboarding has been stopped.",
    }),
    errorToast: () => ({
      message: "Failed to stop Smrt-Core onboarding. Please try again.",
    }),
  }
);
